import React from "react";
import Selector from "../Selector";
import MilestoneModel from "../MilestoneModel";
import RevenueShareModel from "../RevenueShareModel";

const PaymentPlan = ({ formik }) => {
	return (
		<div>
			{formik?.values?.paymentModel === "SubscriptionModel" ? (
				<Selector
					noneValue={"Select Payment Plan"}
					label={"Payment Plan"}
					options={[
						{ label: "Monthly", value: "Monthly" },
						{ label: "Quarterly", value: "Quarterly" },
						{ label: "Bi-Annual", value: "BiAnnual" },
						{ label: "Annual", value: "Annual" },
					]}
					name={"paymentPlan"}
					formik={formik}
				/>
			) : formik?.values?.paymentModel === "MilestoneModel" ? (
				<MilestoneModel formik={formik} />
			) : formik?.values?.paymentModel === "RevenueShare" ? (
				<RevenueShareModel formik={formik} />
			) : null}
		</div>
	);
};

export default PaymentPlan;
